import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { MotionPreferencesProvider } from './motion/preferences';
import { AppModeProvider } from './state/appMode';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MotionPreferencesProvider>
      <AppModeProvider>
        <App />
      </AppModeProvider>
    </MotionPreferencesProvider>
  </StrictMode>,
);
